// extracted by mini-css-extract-plugin
export var addButton = "_dk-0";
export var border = "_dk-8";
export var check = "_dk-h";
export var danger = "_dk-6";
export var dropdownContainer = "_dk-1";
export var editModalBody = "_dk-j";
export var footerContainer = "_dk-i";
export var fullWidth = "_dk-a";
export var hide = "_dk-9";
export var icon = "_dk-3";
export var input = "_dk-7";
export var inputFlex = "_dk-b";
export var inputWrapper = "_dk-c";
export var manualFocus = "_dk-5";
export var optionButton = "_dk-4";
export var pillWrapper = "_dk-e";
export var pointer = "_dk-2";
export var showOverflow = "_dk-f";
export var tagsFlex = "_dk-d";
export var xButton = "_dk-g";